import { Fragment, memo, useContext } from "react";
import appStyles from "../../../App.module.css";
import { CorporateGroupTravelContext } from "../../CorporateGroupTravel";
import { ICorporateGroupTravelContext } from "../../config/interfaces";
const ProgressBar = () => {
  const { currentStep, totalSteps } = useContext(CorporateGroupTravelContext) as ICorporateGroupTravelContext;
  const tempArray = new Array(totalSteps - 1).fill(0);

  return (
    <div className={appStyles.progressWrapper}>
      {tempArray.map((_, index) => (
        <Fragment key={index}>
          <div className={`${appStyles.progressDot} ${index <= currentStep - 1 ? appStyles.progressDone : ""}`}></div>
          {index < totalSteps - 2 && (
            <div
              className={`${appStyles.progressLine} ${index <= currentStep - 2 ? appStyles.progressDone : ""}`}
            ></div>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default memo(ProgressBar);
